module.exports = __webpack_public_path__ + "static/media/Ground-Total.00ac9a0c.webp";